function makeURL(base: string, params: {[key: string]: string}) {
	const urlParams = new URLSearchParams(params);

	return `${base}?${urlParams.toString().replaceAll("*", "%2A")}`;
}

export default makeURL;
